export interface BroadcastCommandSelection {
  broadcastCommandId: number;
  isNow: boolean;
  isLaunch: boolean;
  isReceive: boolean;
}

export interface BroadcastCommandDefinition {
  broadcastCommandId: number;
  label: string;
  disableNow: boolean;
  disableLaunch: boolean;
  disableReceive: boolean;
}

export const BROADCAST_COMMAND_DEFINITIONS: BroadcastCommandDefinition[] = [
  {
    broadcastCommandId: 1,
    label: 'Power mode (active)',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 7,
    label: 'Power mode (low power)',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 2,
    label: 'Download between launch and receive',
    disableNow: true,
    disableLaunch: true,
    disableReceive: false,
  },
  {
    broadcastCommandId: 3,
    label: 'Settings - mag only',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 4,
    label: 'Settings - mag + 22 Hz',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 5,
    label: 'Settings - 22 Hz only',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 8,
    label: 'Settings - off',
    disableNow: false,
    disableLaunch: false,
    disableReceive: true,
  },
  {
    broadcastCommandId: 6,
    label: 'Format disk',
    disableNow: false,
    disableLaunch: true,
    disableReceive: true,
  },
];

export function createDefaultBroadcastCommandSelections(): BroadcastCommandSelection[] {
  return BROADCAST_COMMAND_DEFINITIONS.map((def) => ({
    broadcastCommandId: def.broadcastCommandId,
    isNow: false,
    isLaunch: false,
    isReceive: false,
  }));
}
